import React from 'react';
import BodySection from './BodySection';
// Remove the Footer import from here if it's already inside BodySection

const Home = () => {
  return (
    <div className="w-full min-h-screen flex flex-col bg-white overflow-hidden">
      <div className="flex-grow">
        <BodySection />
      </div>
      {/* REMOVE OR COMMENT OUT THIS LINE */}
      {/* <Footer /> */}
    </div>
  );
};

export default Home;